import { Building2, Scale, MonitorSmartphone, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function WhoWeBuildFor() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 70,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  };

  return (
    <section className="about_us_class_build_section">
      <div className="about_us_class_build_container">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="about_us_class_build_heading_wrap"
        >
          <motion.h2
            initial={{ opacity: 0, y: 70 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.3,
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="about_us_class_build_heading"
          >
            Built for teams where clarity is not optional
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.3,
              duration: 0.8,
            }}
            className="about_us_class_build_subtext"
          >
            Simplifyte is designed for professional services where missing a
            detail means losing a client, a case, or revenue.
          </motion.p>
        </motion.div>

        {/* Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="about_us_class_build_grid"
        >
          {/* Card 1 */}
          <motion.a
            variants={cardVariants}
            whileHover={{
              scale: 1.01,
              transition: { duration: 0 },
            }}
            href="/ca-firms"
            className="about_us_class_build_card about_us_class_build_blue"
          >
            <motion.div
              whileHover={{
                rotate: -8,
                scale: 1.08,
              }}
              transition={{ duration: 0.3 }}
              className="about_us_class_build_icon"
            >
              <Building2 size={22} />
            </motion.div>

            <h3>CA Firms</h3>

            <p className="about_us_class_build_para">
              Manage client documents, deadlines, and multi-step compliance
              workflows without losing sleep over missed emails.
            </p>

            <motion.span
              whileHover={{ x: 4 }}
              className="about_us_class_build_link"
            >
              Learn more <ArrowRight size={16} />
            </motion.span>
          </motion.a>

          {/* Card 2 */}
          <motion.a
            variants={cardVariants}
            whileHover={{
              scale: 1.01,
              transition: { duration: 0 },
            }}
            href="/legal-teams"
            className="about_us_class_build_card about_us_class_build_dark"
          >
            <motion.div
              whileHover={{
                rotate: 8,
                scale: 1.08,
              }}
              transition={{ duration: 0.3 }}
              className="about_us_class_build_icon"
            >
              <Scale size={22} />
            </motion.div>

            <h3>Legal Teams</h3>

            <p className="about_us_class_build_para">
              Keep case files, client communication, and internal review cycles
              tightly organized in a secure, central hub.
            </p>

            <motion.span
              whileHover={{ x: 4 }}
              className="about_us_class_build_link"
            >
              Learn more <ArrowRight size={16} />
            </motion.span>
          </motion.a>

          {/* Card 3 */}
          <motion.a
            variants={cardVariants}
            whileHover={{
              scale: 1.01,
              transition: { duration: 0 },
            }}
            href="/it-services"
            className="about_us_class_build_card about_us_class_build_green"
          >
            <motion.div
              whileHover={{
                rotate: -8,
                scale: 1.08,
              }}
              transition={{ duration: 0.3 }}
              className="about_us_class_build_icon"
            >
              <MonitorSmartphone size={22} />
            </motion.div>

            <h3>IT Service Teams</h3>

            <p className="about_us_class_build_para">
              Track tickets, internal projects, and hardware deployments with
              clear visibility across the entire department.
            </p>

            <motion.span
              whileHover={{ x: 4 }}
              className="about_us_class_build_link"
            >
              Learn more <ArrowRight size={16} />
            </motion.span>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
